module.exports = __webpack_public_path__ + "static/img/HUD-scheme-teal-blue.3d154e1f.jpg";